import {AfterViewInit, Component, Inject, Input, OnInit, DOCUMENT} from '@angular/core';


@Component({
    selector: 'app-insured-items-tab-detail',
    templateUrl: './insured-items-tab-detail.component.html',
    styleUrls: ['./insured-items-tab-detail.component.scss'],
    standalone: false
})
export class InsuredItemsTabDetailComponent implements OnInit, AfterViewInit {
  @Input() tabData: any[] = [];
  @Input() dataCategory = '';

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
    //console.log('tabdata: ', this.tabData);
  }

  ngAfterViewInit(): void {
    const el = document.getElementsByClassName(`insure-tab-${this.dataCategory}`);

    for (let i = 0; i < el.length; i++) {
      el[i].setAttribute('data-category', this.dataCategory);
    }
  }
}
